// Tiny global guard for unsaved voucher forms. Sets a window-level flag while
// a voucher modal is mounted; sidebar/nav clicks check it before navigating.
import { useEffect } from "react";
import { createPortal } from "react-dom";

const FLAG = "__voucherFormOpen";

export function useVoucherFormOpen() {
  useEffect(() => {
    window[FLAG] = true;
    return () => { window[FLAG] = false; };
  }, []);
}

export function isVoucherFormOpen() {
  return !!window[FLAG];
}

export function clearVoucherFormFlag() {
  window[FLAG] = false;
}

export function discardWithConfirm(onClose, label = "this voucher") {
  if (window.confirm(`Are you sure you want to discard ${label}? Any unsaved changes will be lost.`)) {
    clearVoucherFormFlag();
    onClose();
    return true;
  }
  return false;
}

// Render `fixed inset-0` overlays into document.body so they escape parent
// containing blocks created by `.fade-up` (Layout wrapper's `transform`).
// Use this whenever a modal uses `fixed inset-0` and needs to truly fill the
// viewport regardless of where it sits in the React tree.
export function FullScreenOverlay({ children }) {
  if (typeof document === "undefined") return children;
  return createPortal(children, document.body);
}
